/** Fortify Disclosures */

import { GENERAL_INQUIRIES_EMAIL } from "lib/fortifyContact";

export const disclosuresMeta = {
  company: "FORTIFY PORTAL, INC.",
  title: "Disclosures",
  contactLine: `fortifyportal.ca | ${GENERAL_INQUIRIES_EMAIL}`,
};

export const disclosuresIntro =
  'Fortify Portal, Inc. ("Fortify") is a Canadian funding portal built to connect early-stage and small businesses with everyday investors. We are a federally incorporated company based in Toronto, Ontario, operating an online platform that hosts start-up crowdfunding offerings under National Instrument 45-110 — the Canadian Securities Administrators\' framework for start-up crowdfunding.';

export const disclosuresSections = [
  {
    number: "1",
    title: "What We Do",
    paragraphs: [
      "Fortify operates as a neutral marketplace, not an advisor. On our platform:",
    ],
    listItems: [
      'Businesses ("Issuers") can present their offering through a standardized offering document prepared in accordance with NI 45-110.',
      "Before any offering is posted, Fortify confirms the issuer's head office is in Canada and reviews the offering document for completeness against the information NI 45-110 requires. This is a completeness check only — Fortify does not assess the merits of any offering.",
      "Investors can review each offering on their own terms, complete the required risk acknowledgement, and invest up to the limit permitted under the exemption.",
      "Investor funds are only released to an issuer once an offering successfully closes, or returned to investors if it does not.",
    ],
  },
  {
    number: "2",
    title: "Our Approach",
    labeledItems: [
      {
        label: "Transparency",
        text: "We present every offering in a consistent, neutral format. We don't rank, feature, or promote one offering over another.",
      },
      {
        label: "Investor protection",
        text: "The safeguards built into NI 45-110 — risk acknowledgements, a withdrawal right, investment limits, and segregated trust funds — are built into how our platform works.",
      },
      {
        label: "Independence of decision",
        text: "Fortify does not give investment advice and does not assess or endorse the merits of any offering. Every investment decision is made by the investor alone.",
      },
      {
        label: "A focus on Canadian businesses",
        text: "At launch, Fortify supports Canadian start-ups and small businesses, including those in franchise systems, that are looking to raise capital from their community.",
      },
    ],
  },
  {
    number: "3",
    title: "Regulatory Disclosures (National Instrument 45-110)",
    paragraphs: [
      'The following disclosures are provided by Fortify Portal, Inc. in accordance with National Instrument 45-110 — Start-up Crowdfunding Registration and Prospectus Exemptions ("NI 45-110").',
    ],
    subsections: [
      {
        title: "Regulatory Status",
        paragraphs: [
          "Fortify Portal, Inc. is a funding portal relying on the start-up crowdfunding registration exemption under NI 45-110. Fortify is not registered as a dealer or adviser under securities legislation in any jurisdiction of Canada, and is not authorized to, and will not, provide advice about the suitability or the merits of any investment.",
        ],
      },
      {
        title: "How We Hold Your Funds",
        paragraphs: [
          "Fortify holds each purchaser's assets separate and apart from Fortify's own property, in trust for the purchaser, and — in the case of cash — in a designated trust account at a Canadian financial institution.",
        ],
      },
      {
        title: "If Fortify Becomes Insolvent or Ceases Operations",
        paragraphs: [
          "If Fortify makes a general assignment for the benefit of its creditors, becomes subject to any bankruptcy, insolvency, or winding-up proceeding, or the operations of the Platform are discontinued for any reason, Fortify will, within two (2) business days, notify each investor for whom it holds funds, each issuer conducting an offering on the Platform, and the applicable securities regulatory authority of the event and how it affects them. Fortify will return the funds it holds in trust to investors — other than funds properly due to an issuer in respect of an offering that has met all conditions for closing — to the original payment source, promptly and in any event within 5 business days.",
        ],
      },
    ],
  },
  {
    number: "4",
    title: "Our Principals",
    paragraphs: [
      "The following information is provided for each principal (founder, director, officer and control person) of Fortify Portal, Inc.",
    ],
    labeledItems: [
      {
        label: "Full legal name",
        text: "Amro Eltag",
      },
      {
        label: "Position",
        text: "Founder, and CEO",
      },
      {
        label: "Municipality and jurisdiction of residence",
        text: "Toronto, Ontario.",
      },
      {
        label: "Business mailing address",
        text: "1377 The Queensway, Unit 101, Toronto, Ontario M8Z 1T1",
      },
      {
        label: "Business email address",
        text: GENERAL_INQUIRIES_EMAIL,
      },
      {
        label: "Business telephone number",
        text: "1 (855) 827-2752",
      },
    ],
  },
  {
    number: "5",
    title: "Risk",
    paragraphs: [
      "Investing in start-ups and early-stage businesses is risky, and investors may lose the entire amount they invest.",
    ],
  },
  {
    number: "6",
    title: "Contact",
    paragraphs: [
      "Fortify Portal, Inc.",
      "1377 The Queensway, Unit 101, Toronto, Ontario M8Z 1T1",
    ],
    contactLines: [
      {
        label: "Email:",
        value: GENERAL_INQUIRIES_EMAIL,
        href: `mailto:${GENERAL_INQUIRIES_EMAIL}`,
      },
      {
        label: "Website:",
        value: "fortifyportal.ca",
        href: "https://fortifyportal.ca",
      },
    ],
  },
];
